import bowser from "bowser"
// 混音需求
const CHROMEVERSION = 65
// agore replaceTrack need 65+
// const CHROMEVERSION = 65;
// const OPERAVERSION = 45;
// const FIREFOXVERSION = 56;
// const SAFARIVERSION = 11;

/*
* function isBrowserSupport
* 检测系统或者浏览器的兼容性 依赖 bowser 1.x https://github.com/lancedikson/bowser
* @params { object } <os, osver, chrome> osver 系统版本，如window的XP,vista, 或者Android的32.0
* @return { object } <isValidOS: boolean, isValidBrowser: boolean>
*/

const isBrowserSupport = ({ os, osver, chrome }) => {
  // bowser需要1.x的版本，2的API不兼容
  let { name, version, osname, osversion, mac } = bowser
  name = name.toUpperCase()
  version = parseInt(version)
  let isValidOS = true
  let isValidBrowser = true
  if (os && osver) {
    let osnameRegExp = new RegExp(os, "i")
    let osversionRegExp = new RegExp(osver.join("|"), "i")
    if (osnameRegExp.test(osname) && osversionRegExp.test(osversion)) {
      isValidOS = false
    }
  } else if (os) {
    let osnameRegExp = new RegExp(os, "i")
    if (osnameRegExp.test(osname)) {
      isValidOS = false
    }
  }
  if (name === "CHROME") {
    if (version < (chrome || CHROMEVERSION)) {
      isValidBrowser = false
    }
  } else {
    isValidBrowser = false
  }
  return { isValidOS, isValidBrowser, mac }
}

export default isBrowserSupport
